import type {
  Identified,
  SoftDeletable,
  TenantOwned,
  VersionedEntity
} from "../../shared/kernel/entity.js";
import type { PermissionCode, RoleCode } from "./access-types.js";
import type {
  PermissionId,
  RoleId,
  UserClientAccessId,
  UserId
} from "../../shared/kernel/identifiers.js";

export interface Permission extends Identified<PermissionId> {
  readonly code: PermissionCode;
  readonly description: string;
}

export interface Role extends Identified<RoleId>, TenantOwned, VersionedEntity {
  readonly code: RoleCode;
  readonly name: string;
  readonly permissionCodes: ReadonlySet<PermissionCode>;
  readonly systemManaged: boolean;
}

export enum UserClientAccessStatus {
  Active = "ACTIVE",
  Suspended = "SUSPENDED",
  Revoked = "REVOKED"
}

export interface UserClientAccess
  extends Identified<UserClientAccessId>, TenantOwned, VersionedEntity, SoftDeletable {
  readonly userId: UserId;
  readonly roleIds: readonly RoleId[];
  readonly status: UserClientAccessStatus;
}
